import React from "react";
import { connect } from "react-redux";

import { LeafletMap } from "../components/Map";
import { AddressListing } from "../components/Listing";

class Lockers extends React.Component {
  state = {
    focusedMarker: 0
  };

  handleAddressClick = e => {
    const clickedID = e.currentTarget.id;
    const number = parseInt(clickedID.substring(clickedID.indexOf("_") + 1));

    this.setState({ focusedMarker: number });
  };

  render() {
    return (
      <div
        style={{
          flex: 1,
          padding: "20px 20px 0 20px",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <LeafletMap
          markers={
            this.props.userData.lockers &&
            this.props.userData.lockers.map(address => {
              const { lat, lng, name } = address;
              return { lat, lng, name };
            })
          }
          focusOnMarker={this.state.focusedMarker}
        />
        <div style={{ flex: 1, overflow: "auto", marginTop: 15 }}>
          {this.props.userData.lockers &&
          this.props.userData.lockers.length > 0 ? (
            this.props.userData.lockers.map((address, index) => {
              const { address_city, address_state, address_zip } = address;
              const addressRemainder = `${address_city}, ${address_state} ${address_zip}`;

              return (
                <AddressListing
                  key={index}
                  pinNumber={index}
                  name={address.name}
                  street={address.address_street}
                  addressRemainder={addressRemainder}
                  clickAddress={this.handleAddressClick}
                />
              );
            })
          ) : (
            <p style={{ width: "100%", textAlign: "center" }}>
              No lockers found in your area :(
            </p>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

export default connect(mapStateToProps)(Lockers);
